import { Injectable } from '@angular/core';
import { AccountFeatureEnum } from '@anecdotes/api-contracts';
import { ModalWindowService } from '@anecdotes/design-system/modals';
import { ExclusiveFeatureModalComponent } from '../../components/exclusive-feature-modal/exclusive-feature-modal.component';

@Injectable()
export class ExclusiveFeatureModalService {
  constructor(private modalWindowService: ModalWindowService) {}

  openExclusiveFeatureModal(feature: AccountFeatureEnum): void {
    this.modalWindowService.openInSwitcher({
      componentsToSwitch: [
        {
          id: 'exclusive-feature-modal',
          componentType: ExclusiveFeatureModalComponent,
        },
      ],
      context: { feature }
    });
  }
}
